import * as z from 'zod';

export const CreateProductSchema = z.object({
  name: z
    .string({
      message: 'Name is required!',
    })
    .min(4, {
      message: 'Name at least 4 charecter!',
    }),
  // comments: z.string({
  //   message: 'Shelf is required!',
  // }),
  shelf: z.string({
    message: 'Shelf is required!',
  }),
  brand_id: z
    .string({
      message: 'Brand name is required!',
    })
    .refine((v) => v.length > 0, {
      message: 'Select a brand name',
    }),
  generic_id: z
    .string({
      message: 'Generic name is required!',
    })
    .refine((v) => v.length > 0, {
      message: 'Select a generic name',
    }),

  variations: z.array(
    z.object({
      type_id: z
        .string({
          message: 'Type is required!',
        })
        .refine((v) => v.length > 3, {
          message: 'You must select a Type !',
        }),
      unit_id: z
        .string({
          message: 'Unit is required!',
        })
        .refine((v) => v.length > 3, {
          message: 'You must select a Unit !',
        }),
      strength_id: z
        .string({
          message: 'Strength is required!',
        })
        .refine((v) => v.length > 3, {
          message: 'You must select a Strength !',
        }),
      purchase_price: z.coerce.number().refine((v) => v > 0, {
        message: 'Price should grater then 0',
      }),
      wholesale_price: z.coerce.number().refine((v) => v > 0, {
        message: 'Price should grater then 0',
      }),
      retail_price: z.coerce.number().refine((v) => v > 0, {
        message: 'Price should grater then 0',
      }),
    }),
  ),
});
